import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=24ebe34c&"
import script from "./TableFooter.vue?vue&type=script&lang=js&"
export * from "./TableFooter.vue?vue&type=script&lang=js&"
import style0 from "./TableFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TableFooter.vue"
export default component.exports